import { render } from "./ChangePassword.vue?vue&type=template&id=286b4a7e&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=286b4a7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-286b4a7e"

export default script